import auth0 from 'auth0-js';
import config from '../config/common';

let arr: any = document.URL.match(/page=([a-z]+)/);
let isSignup = false;
if (arr) {
  if (arr[1] === 'signup') {
    isSignup = true;
  }
}

class Auth {
  tokenRenewalTimeout: any;
  userProfile: any;
  cb!: (error: any, result?: any) => void;
  handleAuthRoute: any;
  auth0 = new auth0.WebAuth({
    domain: `${config.domain}`,
    clientID: `${config.clientId}`,
    redirectUri: `${config.redirect_url}/callback?signup=${isSignup}`,
    responseType: 'token id_token',
    scope: 'openid profile',
    audience: `${config.audience}`
  });
  // timeoutAuth = true;

  login() {
    const state = sessionStorage.getItem('ROUTE_STATE') || '/';
    this.auth0.authorize({
      state
    });
  }

  /**
   * Authenticate user by parseHash url
   */
  handleAuthentication = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          return resolve(authResult);
        } else if (err) {
          return reject(err);
        }
      });
    })
  }

  /**
   * Set localStorage session
   * @param authResult
   */
  setSession(authResult: any) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );

    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    localStorage.setItem('state', authResult.state);
  }

  getAccessToken() {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('No access token found');
    }
    return accessToken;
  }

  getProfile = (cb: (err?: any, result?: any) => void) => {
    let accessToken = this.getAccessToken();
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        this.userProfile = profile;
      }
      cb(err, profile);
    });
  }

  /**
   * Remove all localstorage
   * Redirect to login page
   */
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('scopes');
    localStorage.removeItem('userinfo');
    localStorage.removeItem('state');
    localStorage.removeItem('firebase_token')
    sessionStorage.removeItem('ROUTE_STATE');

    window.location.href = `https://${config.domain}/v2/logout?returnTo=${config.redirect_url}/&client_id=${config.clientId}`;
  }

  /**
   * Return if user is logout or not
   * If not logout set a new session
   */
  isAuthenticated() {
    return new Promise((resolve, reject) => {
      this.auth0.checkSession({}, (err, result) => {
        if (err) {
          return reject(err);
        } else {
          this.setSession(result);
          return resolve(result);
        }
      })
    })
  }

  /**
   * Auth0 silent authentication
   * @param cb (err, result)
   */
  checkSSO(cb: (err?: any, result?: any) => void) {
    this.auth0.checkSession({ prompt: 'none' },
      (err, result) => {
        cb(err, result)
      }
    );
  }

  /**
   * Silent Authentication if user not logout
   */
  silentAuthentication = () => {
    return new Promise((resolve, reject) => {
      this.checkSSO((err: any, result: any) => {
        if (err) {
          reject(err)
        } else {
          this.setSession(result);
          resolve(result);
        }
      })
    })
  }
}

const AuthInstance = new Auth();
Object.freeze(AuthInstance);

export default AuthInstance;
